import config from "@/config"
import http from "@/utils/request"

export default {
	add: {
		url: `${config.API_URL}/floorCollection/`,
		name: "添加楼层收藏",
		post: async function(data){
			return await http.post(this.url, data);
		}
	},
    delete: {
		url: `${config.API_URL}/floorCollection/`,
		name: "删除楼层收藏",
		delete: async function(data){
			return await http.delete(this.url, data);
		}
	},
    list: {
		url: `${config.API_URL}/floorCollection/`,
		name: "查询楼层收藏列表",
		get: async function(data){
			return await http.get(this.url, data);
		}
	}
}
